import { render, staticRenderFns } from "./editProposals.vue?vue&type=template&id=2fcff55a&scoped=true&"
import script from "./editProposals.vue?vue&type=script&lang=js&"
export * from "./editProposals.vue?vue&type=script&lang=js&"
import style0 from "./editProposals.vue?vue&type=style&index=0&lang=css&"
import style1 from "./editProposals.vue?vue&type=style&index=1&id=2fcff55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcff55a",
  null
  
)

export default component.exports